import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async list(params) {
        return to(Http.get(window.API_PREFIX + "/price_tables", {params}))
    },
    async get(id) {
        return to(Http.get(window.API_PREFIX + `/price_tables/${id}`))
    },
    async insert(data) {
        return to(Http.post(window.API_PREFIX + `/price_tables`, data))
    },
    async update(id, data) {
        data.append('_method', 'patch')
        return to(Http.post(window.API_PREFIX + `/price_tables/${id}`, data))
    },
    async delete(id) {
        return to(Http.post(window.API_PREFIX + `/price_tables/${id}`, {'_method': 'delete'}))
    },
    async save(data, id) {
        return id ? this.update(id, data) : this.insert(data)
    },
    async simulate(id, data){
        return to(Http.post(window.API_PREFIX + `/price_tables/${id}/simulate`, data))
    }
}

